"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Send, Twitter, Globe } from "lucide-react";
const socialLinks = [{
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
const legalLinks = [{
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Terms of Service",
  href: "#"
}, {
  label: "Cookie Policy",
  href: "#"
}];
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted) {
    return <div className="p-3 bg-primary/10 border border-primary/20 rounded-md">
        <p className="text-sm text-primary font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-2">
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <div className="flex gap-2">
                <Input placeholder="Enter your email" type="email" className="bg-background/50 border-border/50 focus-visible:ring-primary/50" {...field} />
                <Button type="submit" disabled={isSubmitting} size="icon" className="shrink-0">
                  <Send className="size-4" />
                  <span className="sr-only">Subscribe</span>
                </Button>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />
    </Form>;
}
export default function VoltGoFooter() {
  return <section id="voltgo-footer" className="dark bg-background text-foreground">
      <div className="bg-white/[0.03] pt-16 pb-8 border-t border-border/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
            
            {}
            <div className="space-y-6">
              <Link to="/" className="inline-block">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/zapgo_logo_yellow_green.png" alt="ZapGO!" className="h-7 w-auto" />
              </Link>
              <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
                Modern, reliable, and convenient charging solutions. Never run out of battery when you need it most.
              </p>
              <div className="flex items-center gap-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} className="text-muted-foreground hover:text-primary transition-colors" aria-label={social.label}>
                      <Icon className="size-5" />
                    </Link>;
              })}
              </div>
            </div>

            {}
            <div>
              <h3 className="font-semibold text-lg mb-6">Quick Links</h3>
              <MenuProvider menu_id="17">
                <FooterMenu />
              </MenuProvider>
            </div>

            {}
            <div>
              <h3 className="font-semibold text-lg mb-6">Contact Us</h3>
              <ul className="space-y-4 mb-8"><li className="flex items-start gap-3 text-sm text-muted-foreground" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:66vtyc" data-ast-start="5097" data-ast-end="5333"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-map-pin size-4 mt-0.5 shrink-0 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:kvlz86" data-ast-start="5185" data-ast-end="5243"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:gn9jhd" data-ast-start="5262" data-ast-end="5311">aaaaa, 1111 AA&nbsp; Amsterdam</span></li><li className="flex items-center gap-3 text-sm text-muted-foreground" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3pa8k0" data-ast-start="5350" data-ast-end="5558"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-4 shrink-0 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:qprszc" data-ast-start="5679" data-ast-end="6280"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:aphoc4" data-ast-start="6043" data-ast-end="6274"></path></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:g66oli" data-ast-start="6280" data-ast-end="6411">+31 6 xxxx xxxx</span></li><li className="flex items-center gap-3 text-sm text-muted-foreground" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3pa8k1" data-ast-start="5575" data-ast-end="5781"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail size-4 shrink-0 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:cxwxdn" data-ast-start="5664" data-ast-end="5713"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:gkkhh5" data-ast-start="5732" data-ast-end="5759">hello@zapgo.nl</span></li></ul>
              
              <h4 className="font-medium text-sm mb-3 text-foreground/80">Legal</h4>
              <ul className="space-y-2">
                {legalLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div>
              <h3 className="font-semibold text-lg mb-6">Stay Updated</h3>
              <p className="text-muted-foreground text-sm mb-4">
                Subscribe to our newsletter for the latest updates, venue partnerships, and special offers.
              </p>
              <FormProvider formId="footer-newsletter" sectionName="footer" defaultValues={{
              email: ""
            }} submitText="Subscribe" successMessage="Thanks for subscribing!">
                <NewsletterForm />
              </FormProvider>
            </div>
          </div>

          <Separator className="bg-border/20 mb-8" />

          {}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span>. All rights reserved.
            </p>
            
            <div className="flex items-center gap-4">
              <Select defaultValue="en-eur">
                <SelectTrigger className="w-[140px] h-8 text-xs bg-transparent border-border/20">
                  <Globe className="size-3.5 mr-2 text-muted-foreground" />
                  <SelectValue placeholder="Language & Currency" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="en-eur">English (EUR)</SelectItem>
                  <SelectItem value="nl-eur">Nederlands (EUR)</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </div>
    </section>;
}